import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
  Outlet,
} from "react-router-dom";
import "@/App.css";
import { LanguageProvider, supportedLanguages, defaultLanguage } from "@/i18n";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function LangGuard() {
  const { lang } = useParams();
  if (!supportedLanguages.includes(lang)) {
    return <Navigate to={`/${defaultLanguage}`} replace />;
  }
  return <Outlet />;
}

function SiteChrome() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <CookieConsentProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />
              <Route path="/thank_you" element={<ThankYou />} />

              <Route path="/:lang" element={<LangGuard />}>
                <Route element={<SiteChrome />}>
                  <Route index element={<Home />} />
                </Route>
                <Route path="privacy-policy" element={<LegalPage tKey="privacy" />} />
                <Route path="cookie-policy" element={<LegalPage tKey="cookies" />} />
                <Route path="terms-and-conditions" element={<LegalPage tKey="terms" />} />
              </Route>

              <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace />} />
            </Routes>
            <CookieBanner />
          </CookieConsentProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
